import Helper from '@/utils/helper'

const DEFAULT_VOLUME_LEVEL = 1.0

class VolumeSetting {
  constructor ({ volumeLevel, volumeLevelMedia, volumeLevelMediaMuted }) {
    this.volumeLevelTotal = Helper.isDefined(volumeLevel) ? volumeLevel / 100 : DEFAULT_VOLUME_LEVEL
    this.volumeLevelMedia = Helper.isDefined(volumeLevelMedia) ? volumeLevelMedia / 100 : null
    this.volumeLevelMediaMuted = Helper.isDefined(volumeLevelMediaMuted) ? volumeLevelMediaMuted / 100 : null
  }

  getVolumeLevelTotal () {
    return this.volumeLevelTotal
  }

  getVolumeLevelMedia () {
    return this.volumeLevelMedia
  }

  getVolumeLevelMediaMuted () {
    return this.volumeLevelMediaMuted
  }
}

export default VolumeSetting
